module.exports = __webpack_public_path__ + "static/media/IMG_6548.76754ebd.jpg";